export default __webpack_public_path__ + "media/zurb/img/legacy/reel/instructions-3-3f5fad3c0630315c252885f99d225ddd.png";